export default "__VITE_ASSET__CMatoWf9__"